var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 19,
  viewBox: "0 0 22 19",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 7.548v9.1c0 1.15-.99 2.09-2.2 2.09H2.2c-1.21 0-2.2-.94-2.2-2.09l.007-9.1 11.026 4.635L22 7.548zM19.8.738c1.21 0 2.2.94 2.2 2.089v3.332l-10.968 4.669L.008 6.16l.003-3.333c0-1.1.896-2.007 2.033-2.084L2.2.738z",
  fill: "#AAA"
})));
export default SvgIconEmail;